import { axiosRequest } from '@/plugins/axios-common'

export const FastSearchActions = {
  executeFastSearch: async (_, term) => {
    return axiosRequest.
      get('/fast_search', { params: { term } }).
      then(({ data }) => data)
  },
}
